<template>
<div>
    <van-nav-bar title="填写收货地址" left-arrow @click-left="onClickLeft" /> 
    <div class="addressBg">
        <div class="addressHeader">

        </div>
        <div class="addressConfirm">
            <van-address-edit
            :area-list="areaList"
            :address-info="addressInfo"
            save-button-text="保存"
            @save="onSave"
            />
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import click_handler from "../tools/mgtv/click";
import { page_view, click_event } from "../tools/mgtv/analysis";
import { AddressEdit } from 'vant';
import { Toast } from 'vant';
import areaList from '../../node_modules/vant/packages/area/demo/area';
import { NavBar } from 'vant';
import {sendOrderAddr, getUserInfo} from '../api/getData'
import {mapState, mapActions} from 'vuex'
import get_param from '../tools/param';
import { TICKET, ACT_TICKET, ACT_ORDERID } from '../constant/CookieKeys';
import { setStore, getStore } from '../api/mUtils';
Vue.use(AddressEdit).use(NavBar);
export default {
  data() {
    return {
        orderId:'',
        phone:'',
        receiverName:'',
        address:'',
        areaList,
        addressInfo:{
            name:"",
            tel:"",
            address_detail:""
        },
        searchResult: []
    }
  },
    computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'urlParams',
            'ticket',
            'product'
        ]),
    },
  mounted () {
    page_view('地址补充页',this);
  }
  ,
  methods: {
    ...mapActions([
      'getUserInfo',
      'setTicket'
    ]),
    onSave(content) {
        click_handler(
            "地址补充页-保存",
            () => {
                let ticket= this.$route.params.ticket||this.ticket
                if(this.urlParams && this.urlParams.ticket!=null){
                    ticket = this.urlParams.ticket
                    this.setTicket(ticket)//设置当前ticket
                    // setStore(TICKET,ticket)
                    // this.getUserInfo()
                    console.log("Address ticket",ticket)
                    console.log("Address this.ticket",this.ticket)
                }
                if(typeof ticket =="undefined"||ticket==""||ticket==null||ticket=="undefined"){
                    ticket  = getStore(ACT_TICKET)                    
                    this.setTicket(ticket)//设置当前ticket
                    console.log("Address getStore ticket",ticket)
                    console.log("Address getStore this.ticket",this.ticket)
                }
                console.log('get_param("ticket")',get_param("ticket"))
                console.log('get_param("order_id")',get_param("order_id"))
                console.log('this.urlParams',this.urlParams)             
                
                let orderId = this.$route.params.order_id
                if(this.urlParams && this.urlParams.order_id!=null){
                    orderId = this.urlParams.order_id
                }
                if(typeof orderId =="undefined"||orderId==""||orderId==null||orderId=="undefined"){
                    orderId  = getStore(ACT_ORDERID)
                }
                const phone = content.tel 
                const receiverName =  content.name           
                const address= content.province+content.city+content.county+content.address_detail 
                console.log("ticket:",ticket)
                console.log("order_id",orderId)   
                //保存收货地址
                sendOrderAddr(ticket,orderId,phone,receiverName,address).then(res => {            
                    if(res && res.err==0){
                        Toast('保存成功');
                        setTimeout(function(){
                            this.$router.push({path:`/OrderList`});
                        },1000)
                    }
                    else{
                        // Toast(res.msg)
                        Toast("地址保存失败，请联系客服处理：4009770707")
                    }
                })
            },
            {
            need_login: false,
            need_act: true
            },
        this);
        
        
    },
    onClickLeft(){
        this.$router.push({path:`/OrderList`,query:this.$route.query});
    }
  }
}
</script>
<style lang="stylus">
.goApp
    .addressBg
        width 100%
        background-image: radial-gradient(51% 96%, #261E3F 44%, #110F17 97%);
    .addressHeader
        width 100%
        height 4.02rem
        background: url('../../static_niunai/img/addressBg.png') no-repeat;
        background-size: 100% 100%;

    .addressConfirm
        position relative
        font-size 0.3rem
        width 6.9rem
        background-color white 
        margin 0 auto
        border-radius 0.2rem
        .buyPrice
            background transparent
        .coupon
            padding-left 0.5em
        .van-address-edit
            background transparent
        .van-cell-group
            background transparent
        .van-cell
            background transparent
        .van-button--primary
            background-color  #FD6A55
            border  1px solid #FD6A55
        .van-cell
            line-height 0.42rem
            padding 0.54rem 0.44rem 0.33rem 0.44rem
            font-size 0.3rem
        .van-address-edit__buttons
            padding 0
            background transparent
            position relative
            top 1.2rem

            .van-button--normal
                display block
                margin 0 auto
                width 6.8rem
                height 0.9rem
                line-height 0.9rem
                background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
                border-radius 1rem
                font-size 0.32rem
                color #0B0E1A
                border none
        .redColor
            color #FD6A55
        .grayColor
            opacity 0.7
</style>
<style>
[class*=van-hairline]::after{
  border:none
}
</style>


// WEBPACK FOOTER //
// src/pages/Address.vue